import { motion } from "framer-motion";
import { getImage } from "gatsby-plugin-image";
import React, { useState, useEffect } from "react";
import { Col, Grid, Row } from "react-flexbox-grid";

import ImageReveal from "../ImageReveal";
import * as styles from "./styles.module.css";
import Video from "../VideoEmbed";

const NumberedSliderVideo = ({
  images,
  imageAlts,
  titles,
  bodies,
  linkTitles,
  linkUris,
  captions,
  videos,
  thumbnails,
}) => {
  // Make sure the page is loaded to display the video
  const [isLoaded, setIsloaded] = useState(false);
  useEffect(() => {
    setIsloaded(true);
  }, []);

  const [storyIndex, setStoryIndex] = useState(0);
  const numberMotion = {
    hover: { scale: 2, x: 10, color: "#d63d1f" },
    active: { scale: 1.5, x: 5, color: "#d63d1f" },
  };

  return (
    <Grid className="p0">
      <Row between="xs" className="align-center">
        <Col>
          <ul className={styles.numbers}>
            {titles.map((_, i) => (
              <li key={i}>
                <motion.button
                  whileHover="hover"
                  animate={i === storyIndex ? "active" : "inactive"}
                  variants={numberMotion}
                  onClick={() => setStoryIndex(i)}
                  data-story-title={titles[storyIndex]}
                  data-story-number={[storyIndex + 1]}
                >
                  0{i + 1}
                </motion.button>
              </li>
            ))}
          </ul>
        </Col>

        {/* Column for text dependent on video or image */}
        {videos[storyIndex] ? (
          <Col lg={5} className={styles.textCol}>
            <h3 className={styles.title}>{titles[storyIndex]}</h3>
            <div
              dangerouslySetInnerHTML={{
                __html: bodies[storyIndex],
              }}
            ></div>
          </Col>
        ) : (
          <Col lg={6} className={styles.textCol}>
            <h3 className={styles.title}>{titles[storyIndex]}</h3>
            <div
              dangerouslySetInnerHTML={{
                __html: bodies[storyIndex],
              }}
            ></div>
            <div>
              <a
                href={linkUris[storyIndex]}
                data-story-number={[storyIndex + 1]}
                data-story-title={titles[storyIndex]}
              >
                {linkTitles[storyIndex]}
              </a>
            </div>
          </Col>
        )}

        {/* Column for video or image */}
        {videos[storyIndex] ? (
          <Col
            lg={6}
            className="mb3 video-component"
            data-story-title={titles[storyIndex]}
            data-story-number={[storyIndex + 1]}
          >
            {isLoaded && (
              <Video
                featuredVideo={videos[storyIndex]}
                thumbnail={thumbnails[storyIndex]}
                storyPosition={[storyIndex + 1]}
                storyTitle={titles[storyIndex]}
              />
            )}
          </Col>
        ) : (
          <Col
            lg={5}
            className="mb3 video-component"
            data-story-title={titles[storyIndex]}
          >
            <ImageReveal
              alt={imageAlts[storyIndex]}
              image={getImage(images[storyIndex])}
              caption={captions[storyIndex]}
            />
          </Col>
        )}
      </Row>
    </Grid>
  );
};

export default NumberedSliderVideo;
